define('formkit/behavior/form.object.menu.drag.drop.behavior',['require','exports','module','underscore','./base.drag.drop.with.target.behavior'],function(require, exports, module) {
  var _                              = require('underscore');
  var BaseDragDropWithTargetBehavior = require('./base.drag.drop.with.target.behavior');


  var FormObjectMenuDragDropBehavior = BaseDragDropWithTargetBehavior.extend({
    defaults: _.extend({}, BaseDragDropWithTargetBehavior.prototype.defaults, {
      dragDropInstanceName: 'formObjectMenuDragDrop',
      target: '.ui.formObjects',
      useDragHandler: true,
      dragHandle: '.form-object-type:not(.disabled)',
      onDrakeDrop: function(elView, targetView, sourceView, siblingView) {
        var form = targetView.form;
        if (form) {
          var newParent          = form.util.parent(targetView.collection);
          var index              = siblingView? form.util.indexOfChild(newParent, siblingView.model):
                                                form.util.lastChildIndex(newParent) + 1;
          var templateObjectType = elView.model;
          form.insertTemplateObject(newParent, {type: templateObjectType}, index);
        }
      },
      isContainer: false
    })
  });
  module.exports = FormObjectMenuDragDropBehavior;
});

